import { ApplicationModuleOutputWithStatus } from './application-module-output-with-status.model';


export class ApplicationModuleSelectByIdOutput implements IApplicationModuleSelectByIdOutput {
    status!: number;
    message!: string;
    data!: ApplicationModuleOutputWithStatus;

    constructor(data?: IApplicationModuleSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ApplicationModuleOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationModuleSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModuleSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicationModuleSelectByIdOutput {
    status: number;
    message: string;
    data: ApplicationModuleOutputWithStatus;
}

